<template>
  <div>
    <!-- Title and Search Box -->
    <div class="tasks-title-box w-100 rounded pa-2">
      <v-row class="px-5">
        <v-col class="my-auto">
          <h2>لیست خرید</h2>
        </v-col>
        <v-col class="my-auto">
          <v-text-field
              v-model="search_orders"
              label="جست و جو کنید"
              placeholder="حداقل ۳ حرف "
              dense
              outlined
              clearable
              class="search-orders mr-auto py-3"
              style="margin-bottom: -25px; max-width: 200px;"
              :rules="[rules.min_3]"
              @click:clear="$emit('clear')"
              @keydown.enter="handleSearch"
          >
            <template v-slot:append v-if="search_orders?.length >= 3">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="red" v-bind="attrs" v-on="on" @click="handleSearch">mdi-magnify</v-icon>
                </template>
                <span>برای جست و جو کلیک کنید.</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </div>

    <!-- Action Buttons -->
    <div class="tasks-title-box my-5 w-100 rounded">
      <v-row class="text-center">
        <v-col>
          <v-btn v-if="userCanManage" class="elevation-0" @click="$emit('create_order')">
            <v-icon small>mdi-plus</v-icon>
            <div>افزودن</div>
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
              v-if="userCanManage"
              class="elevation-0"
              :loading="loading_reports_pdf"
              @click="$emit('get_report')"
          >
            <v-icon>mdi-file-document</v-icon>
            <div>گزارش گیری</div>
          </v-btn>
        </v-col>
        <v-col>
          <v-btn
              class="elevation-0"
              outlined
              color="red"
              v-if="filtered"
              @click="clearFilter"
          >
            <v-icon>mdi-filter-remove</v-icon>
            <div>حذف فیلتر</div>
          </v-btn>
          <v-btn
              class="elevation-0"
              outlined
              v-else
              @click="show_s_filter = true"
          >
            <v-icon>mdi-filter-outline</v-icon>
            <div>فیلتر پیشرفته</div>
          </v-btn>
        </v-col>
      </v-row>
    </div>

    <!-- Filter Dialog -->
    <OrdersSpecialFilter
        :show_s_filter="show_s_filter"
        @close="show_s_filter = false"
        @filter_by="filter"
    />
  </div>
</template>

<script>
import OrdersSpecialFilter from "@/components/Orders/orders-special-filter.vue";

export default {
  name: "TaskNav",
  components: { OrdersSpecialFilter },
  props: ['orders_count'],
  data() {
    return {
      search_orders: null,
      loading_reports_pdf: false,
      show_s_filter: false,
      filtered: false,
      rules: {
        min_3: v => v?.length >= 3 || 'حداقل ۳ حرف',
      },
    };
  },
  computed: {
    userCanManage() {
      return this.$GLOBAL_DATA.user['degree'] >= 2;
    },
  },
  methods: {
    handleSearch() {
      if (this.search_orders?.length >= 3) {
        this.$emit('search_by_title', this.search_orders);
      }
    },
    clearFilter() {
      this.filtered = false;
      this.$emit('clear');
    },
    filter(filter_by) {
      this.filtered = true;
      this.$emit('filter', filter_by);
    },
  },
};
</script>
